/* istanbul ignore file */
import moment from 'moment';

export default class BulkUpdateRequest {
  public roomId: string;
  public startDate: string;
  public endDate: string;
  public daysOfWeek: string;
  public availabilityType?: string;
  public availabilityQty?: number;
  public amount?: number;
  public updateVariablePricingOnly: number;

  constructor(roomId: string, updateVariablePricingOnly: boolean) {
    this.roomId = roomId;
    this.startDate = moment().format('YYYY-MM-DD');
    this.endDate = moment().format('YYYY-MM-DD');
    this.daysOfWeek = 'Mon,Tue,Wed,Thu,Fri,Sat,Sun';
    this.updateVariablePricingOnly = updateVariablePricingOnly ? 1 : 0;
  }
}
